// In-app dialog system replacing native alert()/confirm() — styleable, matches
// the dark theme, and portable to React Native (window.alert/confirm don't
// exist there). A mounted <DialogHost> registers the real implementations;
// until it mounts (or if it ever unmounts) we fall back to the native dialogs
// so nothing is ever silently swallowed.

export type ConfirmKind = 'info' | 'success' | 'error';
export interface ConfirmOpts {
  message: string;
  title?: string;
  confirmLabel?: string;
  danger?: boolean;
}

let _confirm: ((o: ConfirmOpts) => Promise<boolean>) | null = null;
let _toast: ((message: string, kind?: ConfirmKind) => void) | null = null;

export function registerDialogs(
  c: (o: ConfirmOpts) => Promise<boolean>,
  t: (message: string, kind?: ConfirmKind) => void,
) {
  _confirm = c;
  _toast = t;
}

// Promise-based confirm. `await confirmDialog('Delete?')` → true/false.
export function confirmDialog(message: string, opts: Partial<ConfirmOpts> = {}): Promise<boolean> {
  if (_confirm) return _confirm({ message, ...opts });
  return Promise.resolve(typeof window !== 'undefined' ? window.confirm(message) : true);
}

// Fire-and-forget notification. Replaces alert().
export function toast(message: string, kind: ConfirmKind = 'info') {
  if (_toast) { _toast(message, kind); return; }
  if (typeof window !== 'undefined') window.alert(message);
}
